import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';

import { Routes } from '../../../utils';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import './JobLogs.scss';
import { Dropdown, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import JobLogDetails from './JobLogDetails';
import JobLogSummary from './JobLogSummary';
import JobMenuItems from '../../Header/JobMenuItemsHeader/JobMenuItems';

const JobLogs = ({ match }: any): React.ReactElement => {
    const dropIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'angle-down' }} />;
    const dateTimeIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'clock' }} />;

    const authContext = useAuthContext();
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isViewJobLogsEnabled = authContext.userHasPermission(PermissionEnum.ViewJobLogs);

    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') || tabTitle;
    // const abortController = new AbortController();

    const [jobName, setJobName] = useState('');
    localStorage.setItem('Jobdetails-TabName', jobName);
    const [selectedTab, setSelectedTab] = useState<'summary' | 'details'>('summary');
    const [toggle, setToggle] = useState<'count' | 'time'>('count');
    const {jobId} = useParams()
    const jobIdVal:any = jobId

    return (
        <div className="JobLogs-Container">
            <div className="JobLogs-Header-Container">
                <div className="JobLogs-Header-Text">Job Logs: {jobName}</div>

                <JobMenuItems jobId={jobId ?? "0"} menu='jobLogs'/>
            </div>

            {!isViewJobLogsEnabled ? (
                <div className="NoResult-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
                </div>
            ) : (
                <div>
                    <div className="JobLogs-Tab-Toggle-Container">
                        <div className="JobLogs-Tab-Container">
                            <div className={`JobLogs-Tab ${selectedTab === 'summary' && 'JobLogs-TabSelected'}`}>
                                <span onClick={() => setSelectedTab('summary')}>Summary</span>
                            </div>
                            <div
                                className={`JobLogs-Tab JobLogs-Tab-With-Margin ${selectedTab === 'details' &&
                                    'JobLogs-TabSelected'}`}
                            >
                                <span onClick={() => setSelectedTab('details')}>Details</span>
                            </div>
                        </div>

                        {selectedTab === 'summary' && (
                            <div className="JobLogs-Toggle-Container">
                                Display In
                                <div className="JobLogs-Toggle-Box">
                                    <div
                                        className={`JobLogs-Toggler ${toggle === 'time' && 'JobLogs-Toggler-Right'}`}
                                    />
                                    <div className="JobLogs-Toggle-Count" onClick={() => setToggle('count')}>
                                        Count
                                    </div>
                                    <div className="JobLogs-Toggle-Time" onClick={() => setToggle('time')}>
                                        Time
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {selectedTab === 'summary' ? (
                        <JobLogSummary jobId={parseInt(jobIdVal)} setJobName={setJobName} toggle={toggle} />
                    ) : (
                        <JobLogDetails jobId={parseInt(jobIdVal)} />
                    )}
                </div>
            )}
        </div>
    );
};

export default JobLogs;
